// Registers the Video.js v10 audio skin elements. The players come from videojs_players, imported first.
// Imported only by media--audio-player, so elements register only where it loads.
import "videojs_players";
import "@videojs/html/ui/mute-button";
import "@videojs/html/ui/play-button";
import "@videojs/html/ui/playback-rate-button";
import "@videojs/html/ui/seek-button";
import "@videojs/html/ui/slider-buffer";
import "@videojs/html/ui/slider-fill";
import "@videojs/html/ui/slider-preview";
import "@videojs/html/ui/slider-thumb";
import "@videojs/html/ui/slider-track";
import "@videojs/html/ui/slider-value";
import "@videojs/html/ui/time";
import "@videojs/html/ui/time-slider";
import "@videojs/html/ui/time-slider-chapter-title";
import "@videojs/html/ui/time-slider-chapters";
import { registerIcons } from "@videojs/html/icons";
import {
  pauseIcon,
  playIcon,
  seekIcon,
  volumeHighIcon,
  volumeOffIcon
} from "@videojs/html/icons/compat";

registerIcons("scaffold", {
  pause: pauseIcon,
  play: playIcon,
  seek: seekIcon,
  "volume-high": volumeHighIcon,
  "volume-off": volumeOffIcon
});
